import React, { useEffect } from 'react'
import { Spin } from 'antd'
import useGlobalConfigStore from '@/stores/globalConfig'

let interval: any,
  flag = false

export default function Loading() {
  const loading = useGlobalConfigStore(state => state.loading)

  const [spinning, setSpinning] = React.useState(false)
  const [percent, setPercent] = React.useState(0)

  useEffect(() => {
    if (loading) {
      setSpinning(true)
      flag = true
      let ptg = -20
      interval = setInterval(() => {
        ptg += 5
        setPercent(ptg)
        if (ptg === 90) {
          clearInterval(interval)
        }
      }, 200)
    } else if (flag) {
      flag = false
      if (interval) {
        clearInterval(interval)
      }
      setPercent(100)
      setTimeout(() => {
        if (flag) {
          return
        }
        setSpinning(false)
        setPercent(0)
      }, 1000)
    }
  }, [loading])

  return <Spin spinning={spinning} tip='Loading...' percent={percent} fullscreen size='large' />
}
